// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1yaWD","button-small":"Button_button-small__33bYz"};